// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { Box, Button, Typography } from '@mui/material';

export const NotFound: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography variant="h1" sx={{ mb: 4 }}>
        Oops!
      </Typography>
      <Typography variant="body1">The page you were trying to reach does not exist.</Typography>
      <Typography variant="body1" sx={{ mb: 4 }}>
        Click the link below to return to the home page.
      </Typography>

      <Button href="/">Go home</Button>
    </Box>
  );
};
